import { IBaseOption } from '~/utils/interface/common';
import { ReviewSourceEnum, StatusEnum } from '../enum/common';

export const mockDataUnitEstimate: IBaseOption[] = [
  { label: 'Plumbing', value: 'PLUMBING' },
  { label: 'HVAC', value: 'HVAC' },
];

export const mockDataEstimateTag: IBaseOption[] = [
  { label: 'Residential New', value: 'RESIDENTIAL_NEW' },
  { label: 'Residential Repeat', value: 'RESIDENTIAL_REPEAT' },
  { label: 'Commercial New', value: 'COMMERCIAL_NEW' },
  { label: 'Commercial Repeat', value: 'COMMERCIAL_REPEAT' },
];

export const mockDataEstimateSource: IBaseOption[] = [
  { label: 'Google', value: 'GOOGLE' },
  { label: 'Billboard', value: 'BILLBOARD' },
  { label: 'Yellow Pages', value: 'YELLOW_PAGES' },
  { label: 'Website', value: 'WEBSITE' },
  { label: 'Referral', value: 'REFERRAL' },
];

export const mockDataEstimateFieldsType: IBaseOption[] = [
  { label: 'Gas', value: 'GAS' },
  { label: 'Water Heater', value: 'WATER_HEATER' },
  { label: 'Mainline Backup', value: 'MAINLINE_BACKUP' },
  { label: 'Secondary Line Backup', value: 'SECONDARY_LINE_BACKUP' },
  { label: 'Leak', value: 'LEAK' },
  { label: 'Remodel or Addition', value: 'REMODEL_OR_ADDITION' },
  { label: 'Fixture Repair (Toilet, faucet)', value: 'FIXTURE_REPAIR' },
  { label: 'Slab Leak', value: 'SLAB_LEAK' },
  { label: 'Other', value: 'OTHER' },
];

export const mockDateDiscountEstimate: IBaseOption[] = [
  { label: 'Percentage (%)', value: 'PERCENTAGE' },
  { label: 'Dollar ($)', value: 'DOLLAR' },
];

export const mockDateTypeChecklistEstimate: IBaseOption[] = [
  { label: 'Checkbox', value: 'CHECKBOX' },
  { label: 'Text', value: 'TEXT' },
  { label: 'Pass/Flag/Fail', value: 'PASS_FLAG_FAIL' },
];

export const mockDataEstimateStatus: IBaseOption[] = [
  {
    label: 'All',
    value: 'ALL',
  },
  {
    label: 'Scheduled',
    value: StatusEnum.SCHEDULED,
  },
  {
    label: 'UnScheduled',
    value: StatusEnum.UNSCHEDULED,
  },
  {
    label: 'Awaiting Approval',
    value: StatusEnum.AWAITING_APPROVAL,
  },
  {
    label: 'Won',
    value: StatusEnum.WON,
  },
  {
    label: 'Lost',
    value: StatusEnum.LOST,
  },
  {
    label: 'Accepted',
    value: StatusEnum.ACCEPTED,
  },
  {
    label: 'Convert To Job',
    value: StatusEnum.CONVERT_TO_JOB,
  },
];

export const mockDataChangeStatusEstimate: IBaseOption[] = [
  {
    label: 'Won',
    value: StatusEnum.WON,
  },
  {
    label: 'Lost',
    value: StatusEnum.LOST,
  },
  {
    label: 'Accepted',
    value: StatusEnum.ACCEPTED,
  },
];

export const mockDataReviewSource: IBaseOption[] = [
  {
    label: 'Internal',
    value: ReviewSourceEnum.INTERNAL,
  },
  {
    label: 'Google',
    value: ReviewSourceEnum.GOOGLE,
  },
];

export const mockDataReviewRating: IBaseOption[] = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
];
